import React from 'react';
import withWebsiteContent from '../../../common/withWebsiteContent';
import { sectionScrollMarginSx } from '../../../common/hooks/useScrollSpyHash';
import { Box, Container, Typography, Paper, Stack } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ScheduleIcon from '@mui/icons-material/Schedule';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';

/**
 * Practical info: address, check-in/out, additional note.
 */
export const PracticalInfoPure = ({ id, title, address, checkIn, checkOut, email, phone, note, images = [] }) => {
  const hasAny = title || address || checkIn || checkOut || email || phone || note;
  if (!hasAny) return null;

  return (
    <Box id={id} component="section" sx={{ ...sectionScrollMarginSx, py: 6, backgroundColor: 'grey.50' }}>
      <Container>
        {title && (
          <Typography
            variant="h4"
            component="h2"
            sx={{ textAlign: 'center', mb: 4, fontWeight: 600 }}
          >
            {title}
          </Typography>
        )}
        <Paper
          variant="outlined"
          sx={{
            p: 4,
            maxWidth: 560,
            mx: 'auto',
            borderRadius: 2,
            borderColor: 'divider',
          }}
        >
          <Stack spacing={2}>
            {address && (
              <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
                <LocationOnIcon color="action" sx={{ mt: 0.25 }} />
                <Box>
                  <Typography variant="subtitle2" color="text.secondary">
                    Adres
                  </Typography>
                  <Typography variant="body1">{address}</Typography>
                </Box>
              </Box>
            )}
            {(checkIn || checkOut) && (
              <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
                <ScheduleIcon color="action" sx={{ mt: 0.25 }} />
                <Box>
                  <Typography variant="subtitle2" color="text.secondary">
                    Zameldowanie / wymeldowanie
                  </Typography>
                  <Typography variant="body1">
                    {checkIn && <>Zameldowanie: {checkIn}</>}
                    {checkIn && checkOut && <br />}
                    {checkOut && <>Wymeldowanie: {checkOut}</>}
                  </Typography>
                </Box>
              </Box>
            )}
            {email && (
              <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
                <EmailIcon color="action" sx={{ mt: 0.25 }} />
                <Box>
                  <Typography variant="subtitle2" color="text.secondary">
                    E-mail
                  </Typography>
                  <Typography
                    variant="body1"
                    component="a"
                    href={`mailto:${email}`}
                    sx={{ color: 'inherit', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
                  >
                    {email}
                  </Typography>
                </Box>
              </Box>
            )}
            {phone && (
              <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
                <PhoneIcon color="action" sx={{ mt: 0.25 }} />
                <Box>
                  <Typography variant="subtitle2" color="text.secondary">
                    Telefon
                  </Typography>
                  <Typography
                    variant="body1"
                    component="a"
                    href={`tel:${phone.replace(/\s/g, '')}`}
                    sx={{ color: 'inherit', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
                  >
                    {phone}
                  </Typography>
                </Box>
              </Box>
            )}
            {note && (
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                {note}
              </Typography>
            )}
          </Stack>
        </Paper>
      </Container>
    </Box>
  );
};

const PracticalInfo = withWebsiteContent(PracticalInfoPure);
PracticalInfo.displayName = 'PracticalInfo';

export default PracticalInfo;
